import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent, BaseComponentMode } from "@impacgroup/angular-baselib";
import { V2AdminSimCardDetailResponseDTO } from "@impacgroup/doerr-wildkamera-api-dtos";
import { SimCardsService } from "./simcards.service";

@Component({
    selector: "app-simcarddetail",
    templateUrl: "./simcarddetail.component.html",
    styleUrls: ["simcarddetail.component.scss"],
    standalone: false
})
export class SimCardDetailComponent extends BaseComponent implements OnInit {
    private simCardId?: string;
    public simCard?: V2AdminSimCardDetailResponseDTO;

    public UTCDATEFORMAT?: string;

    constructor(private route: ActivatedRoute, private simCardsService: SimCardsService, private router: Router, private _location: Location) {
        super();
        this.UTCDATEFORMAT = this.simCardsService.UTCDATEFORMAT;

        this.subscriptions.push(
            this.route.params.subscribe((params) => {
                this.simCardId = params["id"];
                if (this.simCardId) {
                    this.initViewMode();
                }
            })
        );
    }

    ngOnInit(): void {}

    initViewMode() {
        this.MODE = BaseComponentMode.VIEW;

        if (!this.simCardId) {
            return;
        }

        this.subscriptions.push(
            this.simCardsService.simCardDetail(this.simCardId).subscribe({
                next: (result) => {
                    this.simCard = result;
                },
                error: (err) => {
                    this.router.navigate(["../"], { relativeTo: this.route });
                }
            })
        );
    }

    back() {
        this._location.back();
    }
}
